import React from 'react';
import moment from 'moment';
import { Pill, Tone } from '../ui';
import { TimelineGateway, TimelineGatewayStatus } from './statusTimelineUtils';

type Props = {
  gateways: TimelineGateway[];
};

function formatAgo(iso: string | null | undefined): string {
  if (!iso) return '—';
  const m = moment(iso);
  return m.isValid() ? m.fromNow() : iso;
}

function formatAbsolute(iso: string | null | undefined): string {
  if (!iso) return '—';
  const m = moment(iso);
  return m.isValid() ? m.format('DD/MM/YYYY HH:mm:ss') : iso;
}

function statusLabel(status: TimelineGatewayStatus): string {
  if (status === 'online') return 'Online';
  if (status === 'offline') return 'Offline';
  return 'Unknown';
}

function statusTone(status: TimelineGatewayStatus): Tone {
  if (status === 'online') return 'good';
  if (status === 'offline') return 'bad';
  return 'neutral';
}

function buildTooltip(gateway: TimelineGateway): string {
  const lines = [
    `Checked: ${formatAbsolute(gateway.checkedAt)}`,
    `Status updated: ${formatAbsolute(gateway.latestStatusUpdate)}`,
  ];
  if (gateway.macAddress) lines.push(`MAC: ${gateway.macAddress}`);
  if (gateway.antennaType) lines.push(`Antenna: ${gateway.antennaType}`);
  if (gateway.releaseVersion != null) lines.push(`Release: ${gateway.releaseVersion}`);
  return lines.join('\n');
}

const StatusTimelineGatewayCards: React.FC<Props> = ({ gateways }) => {
  if (!gateways.length) return null;

  return (
    <>
      {gateways.map((gateway) => (
        <div key={gateway.gatewayName} className="sq-context-card" title={buildTooltip(gateway)}>
          <div className="sq-context-card-top">
            <span className="sq-context-card-name">{gateway.gatewayName}</span>
            <Pill tone={statusTone(gateway.gatewayStatus)}>{statusLabel(gateway.gatewayStatus)}</Pill>
          </div>
          <span className="sq-muted">Checked {formatAgo(gateway.checkedAt)}</span>
        </div>
      ))}
    </>
  );
};

export default StatusTimelineGatewayCards;
